/**
 * Helper functions files.js
 *
 * @namespace files
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/files.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */


/**
 * @function files.readJSONFileToObject
 * @param {*} filePath
 * @param {*} nullOnFail
 * @param {*} headers
 */
export function readJSONFileToObject(filePath, nullOnFail, headers = null) {
  return new Promise((res, rej) => {
    let reader = new FileReader()

    // Closure to capture the file information.
    reader.onload = function (e) {
      try {
        res(JSON.parse(e.target.result))
      } catch (ex) {
        if (nullOnFail) return res(null)
        rej(`Failed to parse the found json (${filePath}): ${ex}`)
      }
    }

    let data = {
      headers: new Headers(
          headers
        )
    }

    fetch(filePath, data).then((response) => {
      if (response.status !== 200){
        if (nullOnFail) return res(null)
        rej(`Failed loading file (${filePath}) from server: [${response.status}] ${response.statusText}`)
      }else{
        response.blob().then((data) => reader.readAsText(data))
      }
    })
  })
}

export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}